import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 25%;
  height: 100%;
  min-height: 100vh;
  margin: auto;
`;

export const Title = styled(typography.H1BoldTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;

export const SubTitle = styled(typography.P1BoldTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.grey300};
`;

export const Info = styled(typography.P1BoldTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;

export const InfoBtn = styled.span`
  margin-inline-start: 10px;
  color: ${({ theme }) => theme.colors.blueMain};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 48px;

  ${({ enableLeadingText, theme }) =>
    enableLeadingText &&
    `
    &:before {
      content: '+20';
      display: flex;
      align-items: center;
      justify-content: center;
      width: 48px;
      height: 100%;
      color: ${theme.colors.black};
      background-color: ${theme.colors.grey006};
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  `}

  &:after {
    content: ${({ icon }) => icon};
    font-family: 'Icomoon';
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 100%;
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.blueMain};
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;

export const Input = styled.input`
  flex-grow: 1;
  padding: 14px 20px;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.black};
  background-color: ${({ theme }) => theme.colors.blueLight};
  border: none;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  box-sizing: border-box;

  ::-webkit-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  ::-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-ms-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }

  &:focus {
    border: none;
    outline: none;
  }
`;

export const ValidationErrMsg = styled(typography.P2RegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.redMain};
`;

export const SubmitBtn = styled(typography.P2BoldTypography)`
  width: 100%;
  padding: 8px 0;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.blueMain};
  border: 1px solid ${({ theme }) => theme.colors.blueMain};
  border-radius: 4px;
  cursor: pointer;

  ${({ disabled, theme }) =>
    disabled &&
    `
    color: ${theme.colors.white};
    background-color: ${theme.colors.grey005};
    border: 1px solid ${theme.colors.grey005};
  `}
`;

export const SignUpBtn = styled(SubmitBtn)`
  color: ${({ theme }) => theme.colors.blueMain};
  background-color: ${({ theme }) => theme.colors.white};
  border: 2px solid ${({ theme }) => theme.colors.blueMain};
`;

export const DisclaimerInfo = styled(typography.P4RegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;
